module.exports = __webpack_public_path__ + "img/childcheckin.4ea623ea.svg";